import React from 'react';

const RequiredIndicator = ({ color = '#E76767' }) => {
    return <span style={{ color }}> *</span>;
};

export default RequiredIndicator;
